import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { parseInt } from 'lodash';

import {
  logoContentPropTypes,
  textContentPropTypes,
} from '../../../config/sectionHeader/sectionHeaderPropTypes';
import generateHeaderRichTextEditorId from '../../../utils/generateHeaderRichTextEditorId';
import headerContentAlignment from '../../../config/sectionHeader/headerContentAlignment';
import HeaderLogoEditor from '../HeaderLogoEditor';
import HeaderLogo from '../HeaderLogo';
import HeaderLogoPlaceholderContainer from '../HeaderLogoPlaceholderContainer';
import HeaderTextEditor from '../HeaderTextEditor';
import HeaderText from '../HeaderText';

import styles, {
  containerVerticalPadding,
  logoHorizontalPadding,
  centerAlignContainerHorizontalPadding,
} from './HeaderLogoWithTextContent.scss';

class HeaderLogoWithTextContent extends Component {
  static propTypes = {
    isEditMode: PropTypes.bool,
    ...logoContentPropTypes,
    ...textContentPropTypes,
  };

  static defaultProps = {
    isEditMode: false,
    logoWithTextAlign: headerContentAlignment.left,
    logoImageUrl: '',
  };

  static containerVerticalPadding = parseInt(containerVerticalPadding);
  static logoHorizontalPadding = parseInt(logoHorizontalPadding);
  static centerAlignContainerHorizontalPadding = parseInt(
    centerAlignContainerHorizontalPadding,
  );

  isVerticalAlignment() {
    return this.props.logoWithTextAlign === headerContentAlignment.center;
  }

  calculateHeaderSize() {
    const {
      containerSize: { width, height },
    } = this.props;

    if (this.isVerticalAlignment()) {
      return {
        width:
          width -
          HeaderLogoWithTextContent.centerAlignContainerHorizontalPadding,
        height: height - HeaderLogoWithTextContent.containerVerticalPadding,
      };
    }
    return {
      width:
        ((width - HeaderLogoWithTextContent.logoHorizontalPadding) / 3) * 2,
      height,
    };
  }

  renderLogo(logoClassName, restrictionEnabled) {
    const {
      isEditMode,
      logoImageUrl,
      logoWithTextAlign,
      logoImageLinkUrl,
      logoImageSize,
      logoImageSizePreset,
      logoImageAlign,
    } = this.props;

    const headerSize = this.calculateHeaderSize();

    const shouldRenderLogoPlaceholder = isEditMode && !logoImageUrl;
    if (shouldRenderLogoPlaceholder)
      return (
        <HeaderLogoPlaceholderContainer
          align={logoWithTextAlign}
          containerHeight={headerSize.height}
        />
      );

    const HeaderLogoComponent = isEditMode ? HeaderLogoEditor : HeaderLogo;

    return (
      <HeaderLogoComponent
        restrictionEnabled={restrictionEnabled}
        headerSize={headerSize}
        logoImageUrl={logoImageUrl}
        logoImageAlign={logoImageAlign}
        logoImageLinkUrl={logoImageLinkUrl}
        sizePreset={logoImageSizePreset}
        size={logoImageSize}
        className={logoClassName}
      />
    );
  }

  renderText() {
    const {
      isEditMode,
      textContent,
      clientUuid,
      logoWithTextAlign,
      containerSize: { height: containerHeight },
      logoImageSize: { height: logoHeight = 0 } = {},
    } = this.props;

    const HeaderTextComponent = isEditMode ? HeaderTextEditor : HeaderText;
    const textHeight = Math.max(
      0,
      containerHeight -
        HeaderLogoWithTextContent.containerVerticalPadding * 2 -
        logoHeight,
    );
    const style = this.isVerticalAlignment()
      ? { height: `${textHeight}px` }
      : {};

    return (
      <HeaderTextComponent
        id={generateHeaderRichTextEditorId(clientUuid)}
        content={textContent}
        className={cx(styles.text, styles[`${logoWithTextAlign}AlignText`])}
        style={style}
      />
    );
  }

  render() {
    const { logoWithTextAlign, isEditMode, logoImageUrl } = this.props;
    const shouldRenderLogo = isEditMode || logoImageUrl;
    const restrictionEnabled = !this.isVerticalAlignment();

    return (
      <React.Fragment>
        <div className={styles.mobile}>{this.renderLogo('', true)}</div>
        <div
          className={cx(
            styles.container,
            styles[`${logoWithTextAlign}AlignContainer`],
          )}
        >
          {shouldRenderLogo && (
            <div className={cx(styles[`${logoWithTextAlign}AlignLogo`])}>
              {this.renderLogo(styles.desktop, restrictionEnabled)}
            </div>
          )}
          {this.renderText()}
        </div>
      </React.Fragment>
    );
  }
}

export default HeaderLogoWithTextContent;
